import React from 'react';
import { SettingsComponentProps } from '../../SettingsRouter.component';
import GeneralComponentErrorShield from '../../../general/GeneralComponentErrorShield';
import NewUser from './subComponents/NewUser.component';
import UserList from './subComponents/UserList.component';
import {
  ExternalRoleLabel,
  ExternalUserType,
  roleLabelForUserType,
  userTypeForRole,
} from '../../../../utilities/userRoles';

export const roleTranslator = roleLabelForUserType;

export const roleTranslatorReverse = (
  role: ExternalRoleLabel,
): ExternalUserType => userTypeForRole(role);

const ManageAccounts: React.FC<SettingsComponentProps> = () => {
  return (
    <GeneralComponentErrorShield
      dataObjects={[]}
      customLoadingMessages={[
        'Loading Account Data...',
        'Just a few more seconds...',
      ]}
      customErrorMessage="No Data Available."
    >
      <div className="flex w-full flex-col gap-2 p-1.5">
        <div className="rounded-md border border-gray-200 bg-white p-4 shadow-md">
          <h1 className="mb-2 text-xl font-bold text-mainblue underline">
            Manage Accounts
          </h1>
          <p className="mb-4 text-base text-mainblue">
            Create and manage user accounts for the system.
          </p>

          {/* New User Form */}
          <div className="rounded-md border border-mainblue border-opacity-20 bg-mainblue bg-opacity-10 p-1">
            <NewUser />
          </div>
        </div>

        {/* User List */}
        <div className="rounded-md border border-gray-200 bg-white p-2 shadow-md">
          <div>
            <UserList />
          </div>
        </div>
      </div>
    </GeneralComponentErrorShield>
  );
};

export default ManageAccounts;
